import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    clientIs: 'My client is',
    company: 'a company',
    createClientCta: 'Create client',
    createClientSuccessMessage: 'Your client {0} was successfuly created.',
    createClientSuccessTitle: 'Your client was created',
    createClientTitle: 'Add a new client',
    editClientCta: 'Edit client',
    editClientSuccessMessage: 'Your client {0} was successfuly edited.',
    editClientSuccessTitle: 'Your client was updated',
    editClientTitle: 'Edit your client',
    individual: 'an individual',
  },
  fr: {
    clientIs: 'Mon client est',
    company: 'une organisation',
    createClientCta: 'Ajouter le client',
    createClientSuccessMessage: 'Votre client {0} a bien été créé',
    createClientSuccessTitle: 'Votre client a été créé',
    createClientTitle: 'Ajouter un client',
    editClientCta: 'Modifier le client',
    editClientSuccessMessage: 'Votre client {0} a bien été modifié',
    editClientSuccessTitle: 'Votre client a été modifié',
    editClientTitle: 'Modifier un client',
    individual: 'un particulier',
  },
});

export default locales;
